<template>
    <cell :background="'bg-gray-100 dark:bg-gray-600'" class="z-20 sticky top-0">
        <span v-html="column.header"></span>
    </cell>
</template>

<script>
import Cell from '@/Components/Storemanager/Column/Cell';
import DataColumn from '@/Components/Storemanager/Entities/DataColumn';

export default {
    components: {Cell},
    props: {
        column: {
            type: DataColumn,
            required: true,
        },
    },
};
</script>
